
export default {
  filters: {
    currency: v => isNaN(v) || Number(v).equalTo(0)
      ? Number(0).toFixed(2) // avoid showing -0.00 values
      : Number(v).toFixed(2)
    ,
    money: v => v >= 100 ? parseInt(v / 100) : (v / 100).toFixed(2),
    hideZero: v => Math.abs(v) ? v : '',
  },
}
